import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { styled as materialStyled } from "@mui/material/styles";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";

export class DateTypePicker extends Component {
    onSelect = event => {
        const selectedDateType = event.target[event.target.selectedIndex].id;
        this.props.selectedDateTypeChanged(event, selectedDateType);
    };

    render() {
        return (
            <Div>
                <Select onChange={this.onSelect} disabled={this.props.disabled}>
                    <option id="EFFECTIVE_EVENT">Effective date</option>
                    <option id="PROCESSED">Processed date</option>
                    <option id="EFFECTIVE">Execution date</option>
                    <option id="REPORTING">Reporting date</option>
                </Select>
                <Caret aria-hidden="true" />
            </Div>
        );
    }
}

const Caret = materialStyled(ArrowDropDownRoundedIcon)({
    position: "absolute",
    right: "0px",
    top: "0px",
    fontSize: "1.8rem",
    zIndex: -1
});

export const Select = styled.select`
    background: transparent;
    border: 1px solid #aaa;
    border-radius: 0;
    appearance: none;
    height: 29px;
    padding: 5px;
    width: 170px;
    cursor: pointer;
`;

const Div = styled.div`
    position: relative;
    float: left;
`;

DateTypePicker.propTypes = {
    selectedDateTypeChanged: PropTypes.func,
    disabled: PropTypes.bool
};
